import { Action, createReducer, on } from '@ngrx/store';
import { fromProductTypesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productTypesFeatureKey = 'productTypes';

export interface ProductTypesState {
  productTypesResponse: IStaticDataResponse[];
  productTypesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductTypesState = {
  productTypesFailure: undefined,
  productTypesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductTypesAction.loadProductTypes, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductTypesAction.loadProductTypesSuccess, (state, action) => ({
    ...state,
    productTypesResponse: action.response
  })),

  on(fromProductTypesAction.loadProductTypesFailure, (state, action) => ({
    ...state,
    productTypesFailure: action.error
  }))
);

export const getProductTypesResponse = (state: ProductTypesState) => state.productTypesResponse;
export const getProductTypesFailure = (state: ProductTypesState) => state.productTypesFailure;
export const getProductTypesIsLoaded = (state: ProductTypesState) => state.loaded;
